import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import ContentSection from 'components/ContentSection';
import ContentSectionTitle from 'components/ContentSectionTitle';
import { LinksList, LinksListItem, Link } from './styles';

function SeoLinksBlock(_ref) {
  var title = _ref.title,
      links = _ref.links;
  return /*#__PURE__*/_jsx(ContentSection, {}, void 0, /*#__PURE__*/_jsx(ContentSectionTitle, {}, void 0, title), /*#__PURE__*/_jsx(LinksList, {}, void 0, links.map(function (link) {
    return /*#__PURE__*/_jsx(LinksListItem, {}, link.id, /*#__PURE__*/_jsx(Link, {
      href: link.url,
      title: link.name
    }, void 0, link.name));
  })));
}

export default /*#__PURE__*/memo(SeoLinksBlock);